export const FETCH_LOGGEDIN_USER = "FETCH_LOGGEDIN_USER"
export const FETCH_USER_LIST = "FETCH_USER_LIST"
